import events from "../../constants/events";
import { dispatchEvent } from "../../utilities/customEvents";

import { Base } from "./Base";

const classes = {
  headerTransparent: "header-transparent",
};

const body = document.body;
const tabelOfContentsMobile = document.querySelector(
  ".fixed-table-of-contents-mobile"
);

export class HeaderTrigger extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.addScrollHandlerSubscription();
    this.bindTriggeredListener();
  }

  addScrollHandlerSubscription() {
    dispatchEvent(window, events.ADD_SCROLL_SUBSCRIPTION, {
      selector: "[data-behavior*=header-trigger]",
      eventName: events.SCROLL_HANDLER_TRIGGERED,
    });
  }

  bindTriggeredListener() {
    this.element.addEventListener(events.SCROLL_HANDLER_TRIGGERED, (e) => {
      this.handleTriggered(e.detail.direction);
    });
  }

  handleTriggered(direction) {
    const state = this.element.getAttribute(`data-${direction}`);

    if (state === "filled") {
      body.classList.remove(classes.headerTransparent);
      if (tabelOfContentsMobile){
        tabelOfContentsMobile.classList.remove(
          "fixed-table-of-contents-mobile__transparent"
        );
      }
    }

    if (state === "transparent") {
      body.classList.add(classes.headerTransparent);
      if (tabelOfContentsMobile){
        tabelOfContentsMobile.classList.add(
          "fixed-table-of-contents-mobile__transparent"
        );
      }
    }
  }
}
